<template>
	<section class="post_share">
		<div class="inner">
			<h4 class="h4_share">Share this article</h4>
			<ul class="social">
				<li v-if="email">
					<a
						class="share"
						:href="
							'mailto:?subject=&' +
							title +
							'body=Check out this great article! ' +
							permalink +
							'.'
						"
						target="_blank"
						:title="title"
						onclick="window.open('mailto:?subject=' + encodeURIComponent(document.title) + '&amp;body=Check out this great article! ' +  encodeURIComponent(document.URL)); return false;"
					>
						<img :src="email_icon" />
					</a>
				</li>
				<li v-if="permalink">
					<a
						class="share"
						:href="
							'https://www.linkedin.com/shareArticle?mini=true&url=' +
							permalink +
							'&title=&summary=&source='
						"
						target="_blank"
					>
						<img :src="linkedin_icon" />
					</a>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		email: {
			default: 'info@textureconsulting.com.au',
		},
		linkedIn: {},
		permalink: {},
		title: {},
		linkedin_icon: {},
		email_icon: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

section {
	&.post_share {
		display: grid;
		grid-template-columns: repeat(18, 1fr);
		margin-top: 4rem;
		margin-bottom: 0;
		grid-column: span 12;

		@media (max-width: 1366px) {
			grid-template-columns: 1fr;
			margin-bottom: 0;
			margin-top: 0;
		}

		.inner {
			display: grid;
			grid-template-columns: repeat(16, 1fr);
			grid-column: 1 / span 18;
			row-gap: 1rem;

			@media (max-width: 1366px) {
				grid-template-columns: repeat(12, 1fr);
				grid-column: 1 / span 12;
				padding: 0;
			}

			h4 {
				width: 100%;
				grid-column: 1 / span 16;
				font-size: 0.75rem;
        font-weight: bold;
        color: #ddd;
			}

			ul {
				width: 100%;
				grid-column: 1 / span 16;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;

				@media (max-width: $lg) {
					grid-column: 2 / span 4;
				}

				@media (max-width: 1366px) {
					grid-column: 1 / span 12;
					margin-bottom: 2rem;
				}

				&.social {
					list-style: none;
					padding: 0;
					margin: 0;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					justify-content: flex-start;
					align-items: center;

					li {
						font-size: 1rem;
						color: lighten(#f2f2f2, 20);
						margin: 0;
						line-height: 1.5rem;

						a {
							font-size: 1rem;
							color: #f2f2f2;
							margin: 0;
							line-height: 1.5rem;
							display: flex;
							flex-direction: row;
							align-items: center;
							text-decoration: none;
							border-bottom: 0;

							&:hover {
								color: $edc-red;

								svg {
									path {
										fill: $edc-red;
									}
								}
							}

							svg,
							img {
								// max-width: 30px;
								margin-right: 1rem;
								height: 30px;

								path {
									fill: #f2f2f2;
									transition: all 0.2s ease;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostShare.vue